import { render, staticRenderFns } from "./PcCtaButton.vue?vue&type=template&id=77a0380a&scoped=true"
import script from "./PcCtaButton.vue?vue&type=script&lang=js"
export * from "./PcCtaButton.vue?vue&type=script&lang=js"
import style0 from "./PcCtaButton.vue?vue&type=style&index=0&id=77a0380a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.0__lodash@4_fb6f2845f82ca867f83f204a66169969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0380a",
  null
  
)

export default component.exports